import axios from "axios";

export const createUserMessage = (message) => {
  return {
    text: message,
    sender: "USER",
    messageType: "text",
    ts: new Date(),
  };
};

export const getBotResponse = async ({
  rasaServerUrl,
  sender,
  message = "",
  postback = "",
  metadata = {},
  onLogout,
}) => {
  try {
    console.log("fetching bot response");
    const data = {
      sender,
      metadata,
    };

    if (message) {
      data.message = message;
    }

    if (postback) {
      data.postback = postback;
    }

    console.log("data", data);

    const response = await axios({
      method: "post",
      url: rasaServerUrl,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      data,
      timeout: 10000,
    }).catch((err) => {
      if (err.code === 'ECONNABORTED') {
        throw new Error('API call timed out');
      } else if (err.response && err.response.status !== 401) {
        throw new Error(
          `Mohon login kembali karena sesi anda sudah habis`
        );
      } else if (err.response && err.response.status !== 200) {
        throw new Error(
          `API call failed with status code: ${err.response.status}, message: ${err.response.data.error}`
        );
      }
    });

    console.log("response: helpers.js", response.data);

    console.log("response.intent", response.data.intent);
    
    return response.data;
  } catch (error) {
    console.log("error occurred fetching bot response", error);
    onLogout(error);
    return [];
  }
};
